import DSGStore from "../DSGStore";
import PreviewImage from "../components/PreviewImage";

const Reference = () => {
	const references = [
		{
			title: (
				<>
					Wohnquartier am
					<br />
					Wissenschaftsstandort&nbsp;Ost Dresden
				</>
			),
			clickable: true,
			previewImage: "/assets/references/0/0.jpg",
			previewImageAlt:
				"Wohnquartier am Wissenschaftsstandort Ost Dresden",
			images: [
				"/assets/references/0/0_1000x400.jpg",
				"/assets/references/0/1_1000x400.jpg",
				"/assets/references/0/2_1000x400.jpg",
			],
			points: [
				"Objektart: Grundstück inkl. Projektierung",
				"Transaktionsvolumen: kleiner zweistelliger Millionenbetrag",
				"Bauvolumen: mittlerer zweistelliger Millionenbetrag",
				"Tätigkeit: Transaktionsbegleitung",
			],
			additionalText: (
				<>
					Bei dem Vorhaben handelt es sich um ein rd. 8.700 m² großes
					Grundstück inkl. Projektierung, <br />
					zur Erstellung eines Wohnquartiers mit rd. 130 Wohneinheiten
					& möglicher Gewerbeeinheiten, <br />
					am neuen Wissenschaftsstandort Ost in Dresden.
					<br />
					<br />
					Das Quartier wird die erste Bebauung des neuen
					Wissenschaftsstandortes Ost und legt damit den Grundstein
					für eine weitere prosperierende Entwicklung der sächsischen
					Landeshauptstadt.
					<br />
					<br />
					Seit des Vermarktungsstartes im ersten Quartal 2020 wurde
					das Projekt von uns begleitet.
					<br />
					<br />
					Käufer ist ein institutioneller Investor aus dem bayrischen
					Raum.
				</>
			),
		},
		{
			title: "Gesundheitszentrum Mittelsachsen",
			clickable: true,
			previewImage: "/assets/references/1/0.jpg",
			previewImageAlt: "Test",
			images: [
				"/assets/references/1/0_1000x400.jpg",
				"/assets/references/1/1_1000x400.jpg",
				"/assets/references/1/2_1000x400.jpg",
			],
			points: [
				"Objektart: Medizinisches Versorgungszentrum",
				"Transaktionsvolumen: kleinerer zweitstelliger Millionenbetrag",
				"Tätigkeit: Klassische Vermittlung, teils Transaktionsbegleitung",
			],
			additionalText: (
				<>
					Bei dem Objekt handelt es sich um ein Gesundheitszentrum mit
					einem 10 Jahre Betreibervertrag inkl. Verlängerungsoption
					von 5 Jahren, in der Region Mittelsachsen.
					<br />
					<br />
					Zum Vermarktungsstart war das Objekt mit einer Erbpacht
					versehen,
					<br />
					die durch unser Mitwirken ausgeräumt werden konnte.
					<br />
					<br />
					Das Objekt wurde von einem großen institutionellen
					Healthcare-Investor <br />
					aus dem norddeutschen Raum erworben.
				</>
			),
		},
		{
			title: <>Wohnanlage im Großraum&nbsp;Dresden</>,
			clickable: true,
			previewImage: "/assets/references/2/1.jpg",
			previewImageAlt: "Paris",
			images: [
				"/assets/references/2/0_1000x400.jpg",
				"/assets/references/2/1_1000x400.jpg",
			],
			points: [
				"Objektart: Wohnanlage",
				"Transaktionsvolumen: kleinerer zweitstelliger Millionenbetrag",
				"Tätigkeit: Transaktionsbegleitung",
			],
			additionalText: (
				<>
					Bei diesem Vorhaben handelt es sich um eine im Bau
					befindliche Wohnanlage mit 48 Wohneinheiten im Großraum
					Dresden, in der großen Kreisstadt Freital.
					<br />
					<br />
					Durch das starke Wachstum der sächsischen Landeshauptstadt
					Dresden,
					<br />
					gewinnt Freital als unmittelbare Speckgürtelstadt zunehmend
					an Bedeutung und birgt ein großes Potenzial für die Zukunft.
					<br />
					<br />
					Von der Grundstücksbeschaffung bis zur Veräußerung an den
					Endkäufer
					<br />
					wurde das Vorhaben von uns begleitet.
					<br />
					<br />
					Käufer ist ein Gruppe Privatanleger aus den DACH-Staaten.
				</>
			),
		},
	];

	const handleOpen = (index: number) => {
		const clickedReference = references[index];

		DSGStore.update((state) => {
			state.referenceModalOpen = true;
			state.referenceModalTitle = clickedReference.title;
			state.referenceModalImages = clickedReference.images;
			state.referenceModalPoints = clickedReference.points;
			state.referenceModalAdditionalText =
				clickedReference.additionalText;
		});
	};

	return (
		<div
			className="flex min-h-screen w-full flex-col py-12 md:pt-16 md:pb-32"
			id="reference"
			style={{
				backgroundImage: `url("/assets/references_background.jpg")`,
				objectFit: "cover",
				backgroundSize: "cover",
			}}
		>
			<h1 className="mb-6 text-center text-4xl text-ds-yellow md:text-5xl">
				Auszug aus unseren deutschen Referenzen
			</h1>
			<div className="mt-8 grid flex-1 grid-cols-1 gap-2 md:gap-0 lg:grid-cols-3">
				{references.map((reference, index) => (
					<PreviewImage
						key={index}
						clickHandler={() => {
							if (reference.clickable) handleOpen(index);
						}}
						title={reference.title}
						url={reference.previewImage}
						alt={reference.previewImageAlt}
					/>
				))}
			</div>
		</div>
	);
};

export default Reference;
